import Vue from 'vue'
import { fetchFile, fetchFileStatus, isRunningInElectron, mkdir, writeFile } from '@/utils/electronUtils'

export const initDTQ = () => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    if (!window.dtqWS) {
      window.dtqWS = new WebSocket('ws://127.0.0.1:8011/')
      console.log(window.dtqWS)
      // // TODO -- 调试
      // dtqWS = new WebSocket('ws://192.168.50.180:8011/')
    }
    const pointer = await getDTQBindTeacherData()
    window.dtqWS.onopen = () => {
      console.log('ws连接已建立')
      resolve(window.dtqWS)
    }

    window.dtqWS.onerror = err => {
      console.error('ws连接报错了', err)
    }

    window.dtqWS.onmessage = event => {
      const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data
      if (data.uID && data.uID === pointer?.uID) {
        Vue.prototype.$bus.$emit('pointerMessage', data)
        console.log('pointerMessage', data)
      } else {
        Vue.prototype.$bus.$emit('dtqMessage', data)
        console.log('dtqMessage', data)
      }
    }

    window.dtqWS.onclose = event => {
      console.log('ws连接已断开', event)
      window.dtqWS = null
    }
  })
}

// 重启答题器
export const restartDTQ = () => {
  return new Promise((resolve, reject) => {
    if (window.dtqWS) {
      window.dtqWS.close()
    }
    setInterval(() => {
      if (!window.dtqWS) {
        initDTQ().then(() => {
          resolve(window.dtqWS)
        })
      }
    }, 500)
  })
}

export const sendMessage = data => {
  if (window.dtqWS && window.dtqWS.readyState === 1) {
    console.log('发送给答题器的数据', data)
    window.dtqWS.send(JSON.stringify(data) + '\n')
  }
}

/**
 * 获取绑定答题器的学生数据
 * @param classId 班级id Number
 * @return {Promise<undefined|*>} Object 学生数据， 若无则返回 undefined
 */
export async function getDTQBindData(classId) {
  if (JSON.parse(sessionStorage.getItem('noBindDTQ'))) return undefined
  const url = await window.electron.getUserDataAnswerDevicePath()
  const fileUrl = url + '/bind.json'
  const fileStatus = await fetchFileStatus(fileUrl)
  if (fileStatus === 'empty') {
    return undefined
  }
  const dtqBindData = fetchFile(fileUrl)
  return dtqBindData.classes && dtqBindData.classes[classId]
}

/**
 * 获取绑定答题器的教鞭数据
 * @param classId 班级id Number
 * @return {Promise<undefined|*>} Object 教鞭数据， 若无则返回 undefined
 */
export async function getDTQBindTeacherData() {
  if (!isRunningInElectron()) return
  const url = await window.electron.getUserDataAnswerDevicePath()
  const fileUrl = url + '/bind.json'
  const fileStatus = await fetchFileStatus(fileUrl)
  if (fileStatus === 'empty') {
    return undefined
  }
  const dtqBindData = fetchFile(fileUrl)
  return dtqBindData.teachers && dtqBindData.teachers[0]
}

/**
 * 写入绑定答题器的学生数据
 * @param classId 班级id Number
 * @param data 学生绑定数据 Array
 * @return undefined
 */
export async function setDTQBindData(classId, data) {
  if (!isRunningInElectron()) return
  const url = await window.electron.getUserDataAnswerDevicePath()
  const fileUrl = url + '/bind.json'
  let dtqBindData = {}
  const urlStatus = await fetchFileStatus(url)
  if (urlStatus !== 'directory') {
    // 不存在路径为 ".../answerDevice" 的目录，新建目录
    await mkdir(url)
  } else {
    const fileStatus = await fetchFileStatus(fileUrl)
    // 是否存在路径为 .../answerDevice/bind.json 的文件，若存在，读取数据
    if (fileStatus === 'file') {
      dtqBindData = fetchFile(fileUrl) || {}
    }
  }
  if (dtqBindData.classes) {
    dtqBindData.classes[classId] = data
  } else {
    dtqBindData.classes = {
      [classId]: data
    }
  }
  console.log('写入的文件数据', dtqBindData)
  writeFile(JSON.stringify(dtqBindData), fileUrl)
}

/**
 * 写入绑定答题器的教鞭数据
 * @param data 教鞭绑定数据 Object
 * @return undefined
 */
export async function setDTQBindTeacherData(data) {
  if (!isRunningInElectron()) return
  const url = await window.electron.getUserDataAnswerDevicePath()
  const fileUrl = url + '/bind.json'
  let dtqBindData = {}
  const urlStatus = await fetchFileStatus(url)
  if (urlStatus !== 'directory') {
    // 不存在路径为 ".../answerDevice" 的目录，新建目录
    await mkdir(url)
  } else {
    const fileStatus = await fetchFileStatus(fileUrl)
    // 是否存在路径为 .../answerDevice/bind.json 的文件，若存在，读取数据
    if (fileStatus === 'file') {
      dtqBindData = fetchFile(fileUrl) || {}
    }
  }
  if (dtqBindData.teachers) {
    dtqBindData.teachers[0] = data
  } else {
    dtqBindData.teachers = [data]
  }
  console.log('写入的文件数据', dtqBindData)
  writeFile(JSON.stringify(dtqBindData), fileUrl)
}
